import { createContext } from 'react';

const zohoContext = createContext();

export default zohoContext;
